<template>
    <div class="input-group">
        <div class="input-group-prepend">
	        <div class="input-group-append" v-if="userName">
		        <div class="input-group-text" v-text="userName"></div>
	        </div>
            <span class="input-group-text" v-else>
                <span v-show="isPending" ><i class="fas fa-pulse fa-spinner"></i></span>
                <span v-show="!isPending" ><i class="fa fa-phone"></i></span>
            </span>
        </div>
        <input @change="onChange" v-model="model" :id="id" :name="name"
               class="form-control" :class="status(v)" :readonly="readonly">
	    <slot></slot>
	    <ul class="phone__messages invalid-feedback list-unstyled" v-if="v.$error">
		    <li v-if="!v.required">
			    {{'Phone required' | trans}}
		    </li>
		    <li v-if="!v.integer">
			    {{'Phone must contain only digits' | trans}}
		    </li>
	    </ul>
    </div>
</template>

<script>
    export default {
        props: ['id', 'name', 'className', 'readonly', 'value', 'v'],
        data() {
            return {
                userName: '',
                isPending: false,
                model: ''
            }
        },
	    mounted() {
		    this.model = this.$props.value;
		    this.loadUserData();
	    },
        watch: {
	        value() {
		        this.model = this.$props.value;
		        this.loadUserData();
	        }
        },
        methods: {
        	onChange() {
		        this.$emit('input', this.model);
	        },
            async loadUserData() {
                if(this.model) {
	                this.$emit('loading');
                    this.userName = '';
                    this.isPending = true;
                    let result = await axios.get(`/user/${this.model}/byPhone`)
                        .finally(() => {
                        	this.isPending = false;
	                        this.$emit('completed'); 
                        });
	                this.$store.commit('Clients/setClient', result.data);
                    this.userName = result.data.bpInfo.FirstName + " " + result.data.bpInfo.LastName;
	                this.$emit('found', result.data);
                } else {
	                this.userName = '';
	                this.$emit('reset');
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/phone-group.vue